import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { SMLButton } from '../../../components/primitives/SMLButton';
import { kitMessages } from './kitMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Kit.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface KitEmptyHeadProps {
  title: string;
  canAct: boolean;
  isMaking: boolean;
  onMakeKit: () => void;
  onOpenStudio: () => void;
}

/**
 * The head of a Kit with nothing made (design assets-rethink d2): "Nothing made for <song> yet",
 * "Make the kit" and "Pick one in Studio". The slots below it stay visible, all "Not made".
 */
const KitEmptyHeadComponent: React.FC<KitEmptyHeadProps> = ({ title, canAct, isMaking, onMakeKit, onOpenStudio }) => {
  const intl = useIntl();
  return (
    <div className={styles.empty} data-testid="kit-empty">
      <h3>{intl.formatMessage(kitMessages.emptyTitle, { title })}</h3>
      <p>{intl.formatMessage(kitMessages.emptyBody)}</p>
      {canAct && (
        <div className={styles.emptyActions}>
          <SMLButton variant="primary" onClick={onMakeKit} disabled={isMaking}>
            {intl.formatMessage(kitMessages.emptyMake)}
          </SMLButton>
          <SMLButton onClick={onOpenStudio}>{intl.formatMessage(kitMessages.emptyStudio)}</SMLButton>
        </div>
      )}
    </div>
  );
};

export const KitEmptyHead = TypedMemo(KitEmptyHeadComponent);
